<div class="flex items-center" (mouseenter)="showCopy=true" (mouseleave)="showCopy=false">
    <div [ngClass]="['flex flex-none items-center justify-center w-14 h-14 rounded',iconBackgroundClass,iconClass]">
        <fa-icon *ngIf="icon" class="text-current" [icon]="icon" size="2x"></fa-icon>
    </div>
    <div class="flex-auto ml-4 leading-none">
        <div [hidden]="hideLabel" class="text-sm font-normal text-slate-500">{{label}}</div>
        <div class="mt-2 font-medium text-base text-slate-800">
            <mark>
                <span>{{value}}</span>

                <svg [class.draw]="draw" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 60" preserveAspectRatio="none"
                    stroke="#FEDF17">
                    <path
                        d="m 3.518915,27.827324 c 55.429038,4.081 111.581115,5.822 167.117815,2.867 22.70911,-1.208 45.39827,-0.601 68.126,-0.778 28.38172,-0.223 56.76078,-1.024 85.13721,-1.33 24.17378,-0.261 48.4273,0.571 72.58114,0.571" />
                </svg>
                <svg [class.draw]="draw" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 60" preserveAspectRatio="none"
                    stroke="#fff798">
                    <path
                        d="m 3.518915,27.827324 c 55.429038,4.081 111.581115,5.822 167.117815,2.867 22.70911,-1.208 45.39827,-0.601 68.126,-0.778 28.38172,-0.223 56.76078,-1.024 85.13721,-1.33 24.17378,-0.261 48.4273,0.571 72.58114,0.571" />
                </svg>
            </mark>
        </div>

        <app-progress-item *ngIf="enableProgress" [state]="progressState" [value]="progressValue"></app-progress-item>

    </div>

    <div *ngIf="!showCopy" class="flex items-end justify-end min-w-18 mt-auto ml-6">
        <div *ngIf="rightValue" class="text-base leading-none">{{rightValue}}</div>
        <fa-icon *ngIf="rightIcon" [ngClass]="['ml-1 icon-size-4',rightIconClass]" [icon]="rightIcon"></fa-icon>
    </div>

    <div *ngIf="showCopy" class="flex items-end justify-end min-w-18 mt-auto ml-6">
        <!--  -->
        <button mat-icon-button [matTooltip]="'Copy'" (click)="copyToClipboard()"  (mouseenter)="draw=true" (mouseleave)="draw=false">
            <fa-icon [ngClass]="['ml-1 icon-size-5','text-slate-800']" [icon]="['fal','copy']"></fa-icon>
        </button>
    </div>

</div>